export default __webpack_public_path__ + "static/media/spin-bg-15.6452afc2.png";